import * as React from 'react';
import { useState } from 'react';
import keycloak from '../keycloak';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ApiStatusIndicator } from '../components/features/ApiStatus';
import { ThemeToggle } from '../components/ui/theme-toggle';
import { useTheme } from '../providers/ThemeProvider';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function Login() {
  const [signingIn, setSigningIn] = useState(false);
  const { resolvedTheme } = useTheme();
  const logoSrc = resolvedTheme === 'dark'
    ? '/img/edj-labs-logo-transparent-light.png'
    : '/img/edj-labs-logo-transparent-dark.png';

  const handleLogin = () => {
    setSigningIn(true);
    keycloak.login({ redirectUri: window.location.origin + '/services' });
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-background text-foreground">
      <div className="flex items-center justify-between px-4 py-4 sm:px-8">
        <div className="flex items-center gap-2">
          <img src={logoSrc} alt="EDJ-LABS" className="h-8 w-auto max-w-[160px] object-contain" />
        </div>
        <div className="flex items-center gap-2">
          <ApiStatusIndicator className="hidden sm:inline-flex" variant="pill" />
          <ThemeToggle />
        </div>
      </div>

      <div className="relative flex flex-1 items-center justify-center overflow-hidden px-4 py-12 sm:py-16">
        <div className="absolute inset-0 bg-grid opacity-[0.35] [mask-image:radial-gradient(ellipse_at_center,black_0%,transparent_70%)]" aria-hidden="true" />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-primary/5 pointer-events-none" aria-hidden="true" />

        <div className="relative w-full max-w-md">
          <Card className="overflow-hidden">
            <div className="border-b border-border p-6">
              <h2 className="text-lg font-semibold">Welcome back</h2>
              <p className="mt-1 text-sm text-muted-foreground">Sign in to continue.</p>
            </div>
            <div className="space-y-4 p-6">
              <Button size="xl" className="w-full" onClick={handleLogin} loading={signingIn}>
                Continue
                {!signingIn && <ArrowRightIcon className="h-4 w-4" />}
              </Button>
            </div>
            <div className="border-t border-border bg-muted/30 px-6 py-3 text-center text-xs text-muted-foreground">
              Need help?{' '}
              <a href="mailto:postmaster@edj-labs.com" className="font-medium text-primary hover:underline">
                postmaster@edj-labs.com
              </a>
            </div>
          </Card>
        </div>
      </div>

      <footer className="border-t border-border px-4 py-4 text-center text-xs text-muted-foreground sm:px-8">
        &copy; {new Date().getFullYear()} EDJ-LABS. All rights reserved.
      </footer>
    </div>
  );
}
